export const MONOGRAM_PROPERTIES = [
  'MONOGRAM_OPTIONAL_FONT',
  'MONOGRAM_FONT',
  'MONOGRAM_COLOR_NAME',
  'MONOGRAM_TEXT',
  'MONOGRAM_PLACEMENT_NAME',
];

export const GLYPHS = {
  baroque: {
    offset: [33, 65, 97],
  },
  block: {
    offset: [33, 65, 97],
  },
  'circle-block': {
    offset: [33, 65, 97],
  },
  'circle-script': {
    offset: [33, 65, 97],
  },
  diamond: {
    offset: [33, 65, 97],
  },
  fishtail: {
    offset: [33, 65, 97],
  },
  'modern-shadow': {
    offset: [33, 65, 97],
  },
  'roman-block': {
    offset: [33, 65, 97],
  },
  romanesque: {
    offset: [33, 65, 97],
  },
  'sterling-frame': {
    offset: [33, 65, 97],
  },
  traditional: {
    offset: [33, 65, 97],
  },
};
